import { service } from '../../../helpers/http'

export const ActionIndexLogAccessApi = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'logAccessApi', 
		action: 'index', 
		payload: payload 
	})
} 